/* POSH — محدّد الدولة: شاشة الاختيار + اقتراح الدولة */
(function () {
  'use strict';

  var COUNTRIES = [
    { code: 'SA', flag: '🇸🇦', name: 'السعودية', note: 'الرياض خلال 24 ساعة · 2 د.ك' },
    { code: 'KW', flag: '🇰🇼', name: 'الكويت', note: 'توصيل 1–2 يوم عمل · 2 د.ك' },
    { code: 'AE', flag: '🇦🇪', name: 'الإمارات', note: '2–5 أيام عمل · 5 د.ك' },
    { code: 'QA', flag: '🇶🇦', name: 'قطر', note: '2–5 أيام عمل · 5 د.ك' },
    { code: 'BH', flag: '🇧🇭', name: 'البحرين', note: '2–5 أيام عمل · 5 د.ك' },
    { code: 'OM', flag: '🇴🇲', name: 'عُمان', note: '2–5 أيام عمل · 5 د.ك' }
  ];

  var TRIGGERS = [
    '.dropdown-localization__button',
    '.localization-selector',
    '.drawer-localization__button'
  ].join(',');

  var KEY_CHOICE = 'posh_country_choice';
  var KEY_DISMISS = 'posh_country_prompt_until';

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function current() { return (window.Shopify && window.Shopify.country) || 'KW'; }
  function info(code) {
    for (var i = 0; i < COUNTRIES.length; i++) if (COUNTRIES[i].code === code) return COUNTRIES[i];
    return null;
  }

  function setCountry(code) {
    store(KEY_CHOICE, code);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var f = document.createElement('form');
    f.method = 'post';
    f.action = root + 'localization';
    f.hidden = true;
    f.innerHTML =
      '<input type="hidden" name="form_type" value="localization">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="_method" value="put">' +
      '<input type="hidden" name="country_code" value="' + code + '">' +
      '<input type="hidden" name="return_to" value="' + (location.pathname + location.search) + '">';
    document.body.appendChild(f);
    f.submit();
  }

  function buildSheet() {
    if (document.querySelector('[data-posh-sheet]')) return;
    var cur = current();
    var rows = COUNTRIES.map(function (c) {
      return '<button type="button" class="posh-cs__row' + (c.code === cur ? ' is-on' : '') + '" data-code="' + c.code + '">' +
        '<span class="posh-cs__flag">' + c.flag + '</span>' +
        '<span class="posh-cs__meta"><b>' + c.name + '</b><small>' + c.note + '</small></span>' +
        (c.code === cur ? '<span class="posh-cs__tick">✓</span>' : '') +
        '</button>';
    }).join('');

    var el = document.createElement('div');
    el.className = 'posh-cs';
    el.dataset.poshSheet = '1';
    el.hidden = true;
    el.innerHTML =
      '<div class="posh-cs__back" data-close></div>' +
      '<div class="posh-cs__panel" role="dialog" aria-label="اختر دولة التوصيل">' +
        '<div class="posh-cs__grip"></div>' +
        '<div class="posh-cs__head"><b>وين توصّل طلبك؟</b><button type="button" class="posh-cs__x" data-close aria-label="إغلاق">✕</button></div>' +
        '<div class="posh-cs__rows">' + rows + '</div>' +
        '<p class="posh-cs__foot">التوصيل مجاني للطلبات فوق 40 د.ك · كل الأسعار بالدينار الكويتي</p>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { close(); return; }
      var row = e.target.closest('[data-code]');
      if (row) setCountry(row.dataset.code);
    });
  }

  function open() {
    buildSheet();
    var s = document.querySelector('[data-posh-sheet]');
    s.hidden = false;
    requestAnimationFrame(function () { s.classList.add('is-in'); });
    document.body.style.overflow = 'hidden';
  }
  window.poshOpenCountry = open;

  function close() {
    var s = document.querySelector('[data-posh-sheet]');
    if (!s) return;
    s.classList.remove('is-in');
    document.body.style.overflow = '';
    setTimeout(function () { s.hidden = true; }, 250);
  }

  function paintTriggers() {
    var c = info(current());
    if (!c) return;
    document.querySelectorAll(TRIGGERS).forEach(function (btn) {
      if (btn.dataset.poshCountry) return;
      btn.dataset.poshCountry = '1';
      btn.innerHTML = '<span class="posh-chip"><span class="posh-chip__lbl">التوصيل إلى</span><span class="posh-chip__flag">' + c.flag + '</span><span class="posh-chip__name">' + c.name + '</span><span class="posh-chip__arrow">⌄</span></span>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open();
      }, true);
    });
  }

  function maybeSuggest() {
    if (read(KEY_CHOICE)) return;
    var until = parseInt(read(KEY_DISMISS) || '0', 10);
    if (until && Date.now() < until) return;

    fetch('/browsing_context_suggestions.json')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var det = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!det) return;
        det = String(det).toUpperCase();
        if (det === current()) return;

        var served = info(det);
        var bar = document.createElement('div');
        bar.className = 'posh-geo';
        bar.innerHTML = served
          ? '<span class="posh-geo__txt">شكلك في ' + served.flag + ' ' + served.name + ' — تبي نوصّل لك هناك؟</span>' +
            '<span class="posh-geo__btns"><button type="button" data-go="' + served.code + '">إيه، غيّر</button><button type="button" data-no>لا، خلّها</button></span>'
          : '<span class="posh-geo__txt">حالياً نوصّل لدول الخليج فقط 🤍 اختر دولة التوصيل المناسبة لك</span>' +
            '<span class="posh-geo__btns"><button type="button" data-open>اختر الدولة</button><button type="button" data-no>تصفّح</button></span>';
        document.body.appendChild(bar);
        requestAnimationFrame(function () { bar.classList.add('is-in'); });

        bar.addEventListener('click', function (e) {
          var go = e.target.closest('[data-go]');
          if (go) { setCountry(go.dataset.go); return; }
          if (e.target.closest('[data-open]')) { bar.remove(); open(); return; }
          if (e.target.closest('[data-no]')) {
            store(KEY_DISMISS, String(Date.now() + 14 * 24 * 60 * 60 * 1000));
            bar.classList.remove('is-in');
            setTimeout(function () { bar.remove(); }, 250);
          }
        });
      })
      .catch(function () {});
  }

  function init() {
    paintTriggers();
    setTimeout(maybeSuggest, 1800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', paintTriggers);
})();